import React, { useState } from 'react'
import './Navbar.css';
import { TiThMenu } from "react-icons/ti";
import { ImCross } from "react-icons/im";

function Navbar() {
    const [isMenuOpen, setMenuOpen] = useState(true)
    
    function handleMenu() {
        setMenuOpen(!isMenuOpen)
    }
    return (
        <div className='navbar-header'>
            <div className='navbar-content'>
                <div className='logo-navbar'>
                    <h1>SmallPortStory</h1>
                </div>
                <div className="menu-bar" onClick={handleMenu}>
                    {isMenuOpen ? (<ImCross/>)
                        :
                    (<TiThMenu/>)
                    }
                </div>
                <div className={`url-navbar ${isMenuOpen ? 'active' : ''}`}>
                    <ul>
                        <li>Home</li>
                        <li>About</li>
                        <li>Service</li>
                        <li>Gallery</li>
                        <li>Feedback</li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default Navbar
